export const APP_NAME = 'Zeta Global';
export const PERSIST_STORE_NAME = 'admin';
export const REDIRECT_URL_KEY = 'redirectUrl';
export const ROLES: any = {
	1: 'ADMIN',
	2: 'CLIENT',
	3: 'DEMO',
};
